module.exports = __webpack_public_path__ + "static/img/mobile_member_validity_background.b54f703c.png";